import { render, staticRenderFns } from "./OnTestQueue.vue?vue&type=template&id=bde98d58&scoped=true"
import script from "./OnTestQueue.vue?vue&type=script&lang=ts"
export * from "./OnTestQueue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde98d58",
  null
  
)

export default component.exports